import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import "./TagsList.scss";

const TagsList = ({ selected, onDelete }) => {
  const { t } = useTranslation();

  return (
    <ul className="react-tags__list" role="list">
      {selected.map((tag, index) => (
        <li key={tag.label} className="react-tags__list-item" role="listitem">
          <button
            type="button"
            className="react-tags__tag"
            aria-disabled="false"
            title={t("components.TagAutocomplete.removeTitle", {
              value: tag.label,
            })}
            onClick={() => onDelete(index)}
          >
            <span className="react-tags__tag-name">{tag.label}</span>
          </button>
        </li>
      ))}
    </ul>
  );
};

TagsList.propTypes = {
  onDelete: PropTypes.func,
  selected: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      labelText: PropTypes.string,
    })
  ),
};

export default TagsList;
